import clsx from "clsx";
import { ComponentProps } from "react";

import styles from "@/components/ui/Divider/Divider.module.css";

type Props = ComponentProps<"hr">;

const Divider = (props: Props) => {
    const { className, ...otherProps } = props;

    return <hr {...otherProps} className={clsx(styles.divider_root, className)} />;
};

export { Divider };
export type { Props as DividerProps };
